module.exports = __webpack_public_path__ + "img/001.b38008b9.png";